
export default {
    name: 'ShowInMyFolders',
    props: {
        text: {
            type: String,
            default: ''
        },
        node: {
            type: Object,
            required: true
        },
        label: {
            type: String,
            default: 'عرض في مجلداتي'
        }
    }
}
